import React, { useCallback, useEffect } from 'react';
import { Header } from './Header';
import ErrorBoundary from 'features/ErrorBoundary';
import styles from './dialog.module.scss';
import { Cover } from 'components/Cover';
import { FixedPortal } from 'components/Portal/FixedPortal';

type Props = {
	title: string | React.ReactElement,
	onClose(): void,
	open: boolean,
	children: any,
	size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge' | 'xxxlarge'
	i18nArgs?: string[]
}

const KEY_NAME_ESC = 'Escape';
const KEY_EVENT_TYPE = 'keyup';

export const Dialog = ({ title, onClose, open, children, size = 'medium', i18nArgs = [] }: Props) => {
	const handleEscKey = useCallback(
		(event) => {
			if (event.key === KEY_NAME_ESC) {
				onClose();
			}
		},
		[onClose]
	);

	useEffect(
		() => {
			document.addEventListener(KEY_EVENT_TYPE, handleEscKey, false);

			return () => {
				document.removeEventListener(KEY_EVENT_TYPE, handleEscKey, false);
			};
		},
		[handleEscKey]
	);

	if (!open) {
		return <></>
	}

	return (
		<>
			<Cover />
			<FixedPortal>
				<div className={`${styles.dialog} ${styles[`dialog-${size}`]}`}>
					<Header
						title={title}
						onClose={onClose}
						i18nArgs={i18nArgs}
					/>
					<div className={styles.content}>
						<ErrorBoundary location={typeof title === 'string' ? `Dialog - ${title}` : 'Dialog'}>
							{children}
						</ErrorBoundary>
					</div>
				</div>
			</FixedPortal>
		</>
	)
}
